module.exports = function() {
  return new Worker(__webpack_public_path__ + "e8fc45d67eaab93a4ffa.worker.js");
};